module.exports = "/static/assets/dc890db78d2e7ac9b4bee95649e0d8e8.png";